import routerOptions0 from "/builds/ldseating/ldseating-frontend/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@18.19.130_@vue+compiler-sfc@3.5.22_db0@0.3.4_es_megpm3yjphkhrswrqqruk3wvse/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/ldseating/ldseating-frontend/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}